import React from 'react';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import moment, { utc } from 'moment';
// eslint-disable-next-line no-unused-vars
import fr from 'moment/locale/fr';

// import InnerLink from './InnerLink';
import AddNoteBlock from './AddNoteBlock';

// eslint-disable-next-line no-unused-vars
const NotesBlock = ({ strings, loading, contract, i18n, createNote }) => {
  const { notes } = contract;

  const formatDate = ({ date }) => {
    if (typeof date === 'undefined') return undefined;
    const { fullDateFormat, lang } = i18n;
    moment.locale(lang || 'en');
    return utc(date).format(fullDateFormat);
  };

  const getDate = note => {
    try {
      const date = formatDate({ date: note.create_date });
      return date;
    } catch (error) {
      return '';
    }
  };

  // const getNoteLink = note => {
  //   try {
  //     const { id } = note;
  //     return <InnerLink route={`/note/${id}`} label={id} value={id} />;
  //   } catch (error) {
  //     return '';
  //   }
  // };

  const getMessage = note => {
    try {
      return note.message;
    } catch (error) {
      return '';
    }
  };

  return (
    <div className="notes block">
      <Table className="table risk">
        <TableHead>
          <TableRow>
            {/* <TableCell>{strings['contract.notes.table.id.label'] || 'Id'}</TableCell> */}
            <TableCell>
              {strings['contract.notes.table.createDate.label'] || 'Creation Date'}
            </TableCell>
            <TableCell>{strings['contract.notes.table.message.label'] || 'Message'}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {notes && Array.isArray(notes) && notes.length > 0 ? (
            notes.map(row => (
              <TableRow key={row.id}>
                {/* <TableCell component="th" scope="row">
                  {getNoteLink(row)}
                </TableCell> */}
                <TableCell component="th" scope="row">
                  {getDate(row)}
                </TableCell>
                <TableCell component="th" scope="row">
                  {getMessage(row)}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell component="th" scope="row" colSpan={3}>
                <span style={{ color: 'rgb(143, 143, 143)' }}>
                  {strings['contract.notes.table.nodatafound.label'] || 'No data found'}
                </span>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <AddNoteBlock id={contract.id} strings={strings} createNote={createNote} />
    </div>
  );
};

NotesBlock.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  loading: PropTypes.objectOf(PropTypes.bool).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  contract: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  createNote: PropTypes.func.isRequired
};

NotesBlock.defaultProps = {
  strings: {},
  i18n: {
    compactDateFormat: 'D MMM YYYY',
    dateFormat: 'D MMM YYYY',
    fullDateFormat: 'D MMM YYYY / HH:mm',
    hourFormat: 'HH:mm:ss',
    lang: 'fr'
  }
};
export default NotesBlock;
